import { Injectable } from '@angular/core';
import { CoreService } from '../core/core.service';
import { HttpClient, HttpRequest, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CalcHeaders } from 'src/app/models/calcHeader';
import { pgiCalcItems } from 'src/app/models/pgiCalcItems';

@Injectable({
  providedIn: 'root'
})
export class CalcService {

  constructor(private coreService: CoreService, private http: HttpClient) { }

  getCalc(): Observable<CalcHeaders[]> {
    return  this.http.get<CalcHeaders[]>(this.coreService.appRoot + '/api/calc');
  }

  getDetailsCalculation(id): Observable<pgiCalcItems[]> {
    return this.http.get<pgiCalcItems[]>(this.coreService.appRoot + '/api/calc/' + id);
  }

  getCalcByAuthor(id): Observable<CalcHeaders[]> {
    return  this.http.get<CalcHeaders[]>(this.coreService.appRoot + '/api/calcAuthor/' + id);
  }

  getBalance(id): Observable<number> {
    return this.http.get<number>(this.coreService.appRoot + '/api/getAccountBalance/' + id);
  }

  RecalculateBalance(data): Observable<number> {
    return this.http.post<number>(this.coreService.appRoot + '/api/recalculateAccountBalance/' , data);
  }

  saveChanges(data): Observable<pgiCalcItems[]> {
    return this.http.post<pgiCalcItems[]>(this.coreService.appRoot + '/api/saveChanges/' , data);
  }

  generate(data): Observable<pgiCalcItems[]> {
    return this.http.post<pgiCalcItems[]>(this.coreService.appRoot + '/api/generate/' , data);
  }

  publishAll(data): Observable<string> {
    return this.http.post<string>(this.coreService.appRoot + '/api/publishAll/' , data);
  }
}
